export default {
    light: {
        primary: "#59BFCB",
        secondary: "#5F0106",
        accent: "#59BFCB",
        error: "#E1001A",
        info: "#32B3EE",
        success: "#00961A",
        warning: "#EFA500",
        headerColor: "#3a4f6e",
        // Action butons
        edit: "#ffb469",
        see: "#31CAE3",
        delete: "#ff6571",
        reset: "#9069FF",
    },
    dark: {
        primary: "#59BFCB",
        secondary: "#5F0106",
        accent: "#59BFCB",
        error: "#E1001A",
        info: "#32B3EE",
        success: "#00961A",
        warning: "#EFA500",
        headerColor: "#3a4f6e",
        // Action butons
        edit: "#ffb469",
        see: "#31CAE3",
        delete: "#ff6571",
        reset: "#9069FF",
    },
};
